import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { ConfigCameras } from "app/models/configcamera.model";
import { Observable } from "rxjs";

export abstract class AbConfigCameras extends AppService {
  abstract getAllConfigCameras(filter: AppFilter): Observable<any>;
  abstract allconfigcameras(): Observable<any>;
  abstract saveConfigCameras(configCamera: ConfigCameras): Observable<any>;
  abstract saveAllConfigCameras(configCameras: ConfigCameras[]): Observable<any>;
  abstract deletar(id: number);
  abstract retornarCameras(configCamera: ConfigCameras): Observable<any>;
  abstract listarCameras(config: ConfigCameras): Observable<any>;
  abstract listarCamerasDGuardNovaApi(config: ConfigCameras): Observable<any>;
  abstract getDataCamerasDigifort(config: ConfigCameras): Observable<any>;
  abstract testarECarregarCameras(configCamera: ConfigCameras): Observable<any>;
  abstract Base64Encode(str, encoding: string);
  abstract listarContasSigmaIM(config: ConfigCameras): Observable<any>;
  abstract listarConfigCamerasSigmaIM(config: ConfigCameras, idConta: number): Observable<any>;
  abstract getUrlStreamDigiFortSigma(configCamera: any, dataStrStream: string): string;
  abstract getFeatureFlagDguardNovaApi(): Observable<any>;
}
